var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import GoodService from '../../api/GoodService';
import _ from 'lodash';
import Specification from './components/Specification.vue';
import RegexStr from "../../common/RegexStr";
import viewImgList from '../shopAfterSales/components/viewImgList';
var GoodDetail = (function (_super) {
    __extends(GoodDetail, _super);
    function GoodDetail() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeNames = ["1"];
        _this.baseInfo = {};
        _this.stdList = [];
        _this.tabActive = '0';
        _this.tabGoodActive = '0';
        _this.autoPlay = false;
        _this.showMask = false;
        _this.pdfRegx = new RegExp(RegexStr.pdf);
        _this.viewImgData = [];
        _this.viewImgDefaultIndex = 0;
        return _this;
    }
    GoodDetail.prototype.created = function () {
        this.service = GoodService.getInstance();
        this.getStd();
    };
    GoodDetail.prototype.mounted = function () {
        this.getGoodInfo();
    };
    GoodDetail.prototype.toggleMask = function () {
        this.showMask = !this.showMask;
    };
    GoodDetail.prototype.handleClick = function (tab, event) {
    };
    GoodDetail.prototype.getStd = function () {
        var _this = this;
        this.service.getUnit().then(function (res) {
            if (res.data.success) {
                _this.stdList = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    GoodDetail.prototype.getGoodInfo = function () {
        var _this = this;
        this.service.getGoodDetail({ goods_id: this.goodId }).then(function (res) {
            var data = res.data.data;
            data.main_pic = _.sortBy(data.main_pic, ['selected']).reverse();
            (data.document || []).forEach(function (group) {
                (group.document_list || []).forEach(function (file) {
                    file.url = file.document_pic.url;
                    file.document_group_name = group.document_group_name;
                    file.name = file.document_pic.name;
                });
            });
            _this.baseInfo = data;
            setTimeout(function () {
                _this.$refs.introduction.innerHTML = _this.baseInfo.good_explain;
            });
            var html = "\u57FA\u672C\u4FE1\u606F\n            \uFF08<span class=\"title-item\">ID\uFF1A" + _this.baseInfo.goods_id + "</span><span class=\"title-item\">\u6700\u8FD1\u64CD\u4F5C\u4EBA\uFF1A" + _this.baseInfo.operator + "</span>\n            <span class=\"title-item\">\u6700\u8FD1\u64CD\u4F5C\u65F6\u95F4\uFF1A" + _this.baseInfo.u_time + "</span>";
            if (_this.baseInfo.auditer) {
                html += "<span class=\"title-item\">\u5BA1\u6838\u4EBA\uFF1A" + _this.baseInfo.auditer + "</span><span class=\"title-item\">\u5BA1\u6838\u65F6\u95F4\uFF1A" + _this.baseInfo.atime + "</span>";
            }
            html += '）<i class="el-collapse-item__arrow el-icon-arrow-right is-active"></i>';
            $('.el-collapse-item__header.is-active').html(html);
        });
    };
    GoodDetail.prototype.changeViewImgIndex = function (index, data) {
        var _this = this;
        this.viewImgData = [data[index]];
        this.viewImgDefaultIndex = 0;
        this.$nextTick(function () {
            _this.$refs.viewImgList.show();
        });
    };
    GoodDetail = __decorate([
        Component({
            components: {
                Specification: Specification,
                viewImgList: viewImgList
            },
            filters: {
                toJoin: function (item) {
                    return item ? item.join('、') : item;
                }
            },
            computed: {
                storage_condition_value: function () {
                    var storage_condition_range = this.baseInfo.storage_condition_range || [];
                    var reg = /^[-\d]+$/;
                    return reg.test(storage_condition_range[0]) && reg.test(storage_condition_range[1]) ? storage_condition_range[0] + "\u2103 - " + storage_condition_range[1] + "\u2103" : '';
                }
            }
        })
    ], GoodDetail);
    return GoodDetail;
}(Vue));
export default GoodDetail;
